<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loadingServerSide"
    >
      <template v-slot:item.date_transaction="{ value }">
        {{ dateFormat(value) }}
      </template>

      <template v-slot:item.amount_paid="{ value }">
        {{ formatMoney(value) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip v-if="authPermissions.has('consumer_loans:edit')" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              class="mx-2"
              fab
              dark
              small
              v-bind="attrs"
              color="yellow darken-3"
              v-on="on"
              @click="editTransaction(item)"
            >
              <v-icon dark>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
      <template v-slot:body.append>
        <tr>
          <th class="primary--text">
            Amount Paid
          </th>
          <td />
          <td class="text-right">
            {{ formatMoney(totalAmountPaid) }}
          </td>
          <td />
        </tr>
        <tr>
          <th class="primary--text">
            Total Collectibles
          </th>
          <td />
          <td class="text-right">
            {{ formatMoney(amountBorrowed) }}
          </td>
          <td />
        </tr>
        <tr>
          <th class="primary--text">
            Balance
          </th>
          <td />
          <td class="text-right">
            {{ formatMoney(balance) }}
          </td>
          <td />
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import CLTRepository from '@/repositories/consumer-loan-transaction.repository'
import {
  moneyMixin,
  dateFormatMixin,
} from '@/views/dashboard/mixins/helper.mixins'
import { mapState } from 'vuex'
import { ErrorPopup } from '@/lib/utils'
import { authAxios } from '@/extra-functions/axios.extra'
export default {
  name: 'IndexConsumerLoanTransaction',
  props: {
    propConsumerId: String,
    propConsumerLoanId: String,
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'payer_name',
          sortable: false,
          width: '250px',
        },
        {
          text: 'Date',
          value: 'date_transaction',
          sortable: false,
          width: '150px',
        },
        {
          text: 'Amount Paid',
          value: 'amount_paid',
          sortable: false,
          align: 'right',
        },
        { text: 'Config', value: 'actions', sortable: false, width: '100px' },
      ],
      items: [],
      errors: [],
      loadingServerSide: false,
      fetchTransactionsController: null,
      totalAmountPaid: 0,
      amountBorrowed: 0,
      balance: 0,
    }
  },
  mounted() {
    this.getTransactionsV2()
  },
  computed: {
    ...mapState({
      storeId: (state) => state.settings.storeId,
      transactionUpdated: (state) =>
        state.consumerLoanTransaction.channelUpdate,
      authPermissions: (state) => state.auth.userPermissions,
    }),
  },
  watch: {
    transactionUpdated() {
      this.getTransactionsV2()
    },
  },
  methods: {
    // async getTransactions() {
    //   if (!this.loadingServerSide) {
    //     this.loadingServerSide = true
    //     this.errors = []
    //     const queryString = {
    //       consumer: this.propConsumerId,
    //       consumerLoan: this.propConsumerLoanId,
    //     }
    //     CLTRepository.index(queryString)
    //       .then(({ data }) => {
    //         this.items = data
    //       })
    //       .catch((e) => {
    //         this.errors = errorHandler(e)
    //       })
    //       .then(() => {
    //         this.loadingServerSide = false
    //       })
    //   }
    // },
    async getTransactionsV2() {
      try {
        this.fetchTransactionsController?.abort()
        this.fetchTransactionsController = new AbortController()
        const axios = authAxios()
        const { data } = await axios.get(
          `/v2/consumer-loans/${this.propConsumerLoanId}/transactions`,
          {
            signal: this.fetchTransactionsController.signal,
          },
        )
        this.items = data.transactions
        this.totalAmountPaid = data.total_amount_paid || 0
        this.amountBorrowed = data.amount_borrowed || 0
        this.balance = data.balance || 0
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error(e)
        }
        ErrorPopup.fire('Error', 'Failed to load transactions')
      } finally {
        this.loadingServerSide = false
      }
    },
    editTransaction(item) {
      this.$emit('edit', item)
    },
  },
  mixins: [moneyMixin, dateFormatMixin],
}
</script>
